module.exports = "<div class=\"ui-card padding-xl\"\r\n    max-width=\"lg\"\r\n    style=\"margin:0 auto\">\r\n  <hgroup class=\"ui-item margin-xl\">\r\n    <h3 class=\"h1\"\r\n        flex\r\n        translate>ui.footer.privacy_policy</h3>\r\n    <guest-idioma on-change=\"$ctrl.load(lang)\"></guest-idioma>\r\n  </hgroup>\r\n  <div selectable\r\n      ng-bind-html=\"$ctrl.template\">\r\n    <progress-circular></progress-circular>\r\n  </div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/fanconsultores/components/fan/admin/about/politicas/template.html
// module id = 2711
// module chunks = 0